import { createContext } from "react";

/**
 * @typedef {import('../../types').SubmissionData} SubmissionData
 */

/**
 * @typedef {object} SubmissionContext
 * @property {SubmissionData} submissionData - The name of the user.
 * @property {Function} setSubmissionData - A function to set the name of the user.
 */

/**
 * @type {SubmissionContext}
 */
const SubmissionContext = createContext(null);

export default SubmissionContext;
